import {
  ProductOptionModel,
  ProductOptionListModel,
} from "@vp/product-options-ui";
import {
  StandardConfigurator,
  StandardConfiguratorOption,
} from "@vp/wrangler-data-source";

export type ProductOptionsInfo = {
  currency?: string;
  fractionDigits?: number;
  productOptions?: ProductOptionModel[];
};

export function extractProductOptionsInfo(
  wranglerData: StandardConfigurator | undefined,
): ProductOptionsInfo {
  if (!wranglerData) {
    return {};
  }
  try {
    return {
      currency: wranglerData.price.currency,
      fractionDigits: wranglerData.price.fractionDigits,
      productOptions: wranglerAttributeToProductOptionModel(wranglerData),
    };
  } catch (e) {
    console.error("Fail to extract info from wrangler data", e);
    return {};
  }
}

export function wranglerAttributeToProductOptionModel(
  data: StandardConfigurator,
): ProductOptionModel[] {
  return [
    ...data.attributes.map(
      (attr) =>
        ({
          key: attr.key,
          name: attr.name,
          style: "buttons",
          selectedKey: attr.options.filter((opt) => opt.isSelected)[0]?.key,
          choices: wranglerOptionsToChoices(attr.options),
          isRequired: true,
        }) as ProductOptionModel,
    ),
  ];
}

function wranglerOptionsToChoices(
  options: StandardConfiguratorOption[],
): ProductOptionListModel[] {
  return options.map(
    (option) =>
      ({
        key: option.key,
        name: option.name,
        description: option.description,
        image: option.images[0],
        callouts: option.badges?.map((b) => ({ key: b.id, text: b.text })),
        isCompatible: option.isCompatible,
        incompatibleReasons: option.incompatibleReasons,
        differentialListPrice: option.differentialListPrice,
        differentialDiscountPrice: option.differentialDiscountPrice,
        differentialUnitListPrice: option.differentialUnitListPrice,
        differentialUnitDiscountPrice: option.differentialUnitDiscountPrice,
      }) as ProductOptionListModel,
  );
}

export function getLocalizedAttribute(
  wranglerData: StandardConfigurator | undefined,
  attributeName: string,
): string {
  if (!wranglerData) return "";
  const localizedAttr = wranglerData?.attributes?.find(
    (attr) => attr.key === attributeName,
  )?.name;
  if (!localizedAttr) {
    console.error(`Attribute ${attributeName} not found in wrangler data`);
    return "";
  }
  return localizedAttr;
}

export function getLocalizedOption(
  wranglerData: StandardConfigurator | undefined,
  attributeName: string,
  optionKey: string,
): string {
  if (!wranglerData) return "";
  const localizedOption = wranglerData?.attributes
    ?.find((attr) => attr.key === attributeName)
    ?.options?.find((opt) => opt.key === optionKey)?.name;
  if (!localizedOption) {
    console.error(`${attributeName}: ${optionKey} not found in wrangler data`);
    return "";
  }
  return localizedOption;
}
